import { createContext } from 'react'
import type { Workspace, EngineManager } from '../engine/types'

export const WorkspaceContext = createContext<Workspace | null>(null)
export const EngineManagerContext = createContext<EngineManager | null>(null)
